/**
 * FakeIntersectionObserver
 *
 * Lies to browsers that do not support interaction observer.
 * Just does passthrough of props and says elements are visible.
 *
 * This class is aimed at implementation only inside <LazyRender />.
 * Correct behavior outside of the intented is not guaranteed.
 */
var FakeIntersectionObserver = /** @class */ (function () {
    function FakeIntersectionObserver(callback, options) {
        var t = options.threshold && Array.isArray(options.threshold) ?
            options.threshold :
            [options.threshold || .01];
        this.faked = true;
        this.thresholds = t;
        this.callback = callback;
        this.root = options.root || null;
        this.rootMargin = options.rootMargin || "";
    }
    FakeIntersectionObserver.prototype.disconnect = function () { };
    FakeIntersectionObserver.prototype.observe = function (target) {
        this.callback(this.takeRecords(), {});
    };
    FakeIntersectionObserver.prototype.takeRecords = function () {
        return [{
                isIntersecting: true,
                target: null
            }];
    };
    FakeIntersectionObserver.prototype.unobserve = function (target) { };
    return FakeIntersectionObserver;
}());
export { FakeIntersectionObserver };
//# sourceMappingURL=FakeIntersectionObserver.js.map